import React from "react";

const WaterBottle = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M21.138 5.31a1.103 1.103 0 0 0-1.104-1.103H12.31a1.103 1.103 0 0 0-1.103 1.103v3.31h9.93V5.31Zm-2.759-2.758A.552.552 0 0 0 17.828 2h-3.31a.552.552 0 0 0-.553.552v.551h4.414v-.551ZM10.9 9.724A6.929 6.929 0 0 0 9 14.5v16.741A2.762 2.762 0 0 0 11.759 34h8.827a2.762 2.762 0 0 0 2.759-2.759v-16.74a6.93 6.93 0 0 0-1.899-4.777H10.898ZM24.724 4.76h-2.561c.05.18.076.365.078.551v.552h2.483a.828.828 0 1 1 0 1.655h-2.483v1.104h2.483a1.931 1.931 0 1 0 0-3.862Z"
            fill={fill}
        />
    </svg>
);

export default WaterBottle;
